import { Tooltip } from "radix-ui";
import type { ComponentProps } from "react";

export const TooltipProvider = ({
  delayDuration = 0,
  ...props
}: ComponentProps<typeof Tooltip.Provider>) => (
  <Tooltip.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />
);
